import { useQuery } from 'react-query';
import { ControversyAssessmentListResponse } from './controversyAssessmentTypes';
import { getControversyAssessmentList } from './controversyAssessmentService';

type Props<M> = {
    assessmentId: string;
    onError?: (error: Error) => void;
    onSuccess?: (data: ControversyAssessmentListResponse) => void;
    mapper?: (
        data?: ControversyAssessmentListResponse
    ) => M | ControversyAssessmentListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: ControversyAssessmentListResponse) => data;

export const useGetControversyAssessmentList = <
    M = ControversyAssessmentListResponse
>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    assessmentId,
}: Props<M>) => {
    const query = useQuery<ControversyAssessmentListResponse, Error>(
        ['controversyAssessment', assessmentId],
        () => getControversyAssessmentList(assessmentId),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
